import axios from "axios";

const API_BASE_URL = "https://api.sabrlingua.com";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // FormData لازم يتبعت multipart (المتصفح بيضيف الـ boundary)، وإلا axios بيحوّله لـ JSON ويضيّع الملفات
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      config.headers.delete("Content-Type");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
